import React, { useState, useEffect, useMemo } from "react";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, FormControl, Col, Row, Card, Accordion, Spinner } from "react-bootstrap";
import _ from "lodash";
import ApiAgentCommission from "../../../core/api/api.agentCommission";
import ApiSupplier from "../../../core/api/api.supplier";
import { FormProvider, useForm, Controller } from "react-hook-form";
import DataGrid from "./DataGrid";
import { useLocation, useNavigate } from "react-router-dom";
import { CreateCommissionGroupModal } from "./CreateCommissionGroupModal";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";
import ApiHome from "../../../core/api/api.home";
const AgentCommision = (props) => {
  const [commisionGroups, setCommisionGroups] = useState();
  const [supplierList, setSupplierList] = useState();

  // const [
  //   allCommisionGroupsWithoutPagination,
  //   setAllCommisionGroupsWithoutPagination,
  // ] = useState();
  const [showCreateCommissionGroupModal, setShowCreateCommissionGroupModal] =
    useState(false);
  const [selectedCommissionId, setSelectedCommissionId] = useState(null);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
    reset,
  } = useForm({});
  const methods = {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  };
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  useEffect(() => {
    (async () => {
      // دریافت لیست همه تامین کننده ها
      const suppliersList = await ApiSupplier.getAllSuppliersName();
      setSupplierList(suppliersList);
      try {
        const data = await ApiAgentCommission.getAllAgentCommissions({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
          supplierId: searchParams.get("supplierId"),
        });
        setCommisionGroups(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
          {
            name: "supplierId",
            type: "multiSelect",
            isMulti: false,
            data: suppliersList?.map((item) => ({
              id: item.id,
              title: item.companyName,
            })),
          },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);

      } catch (error) {
        console.log("error :>> ", error);
      }
    })();
  }, []);

  const onSubmit = async (data) => {
    data.supplierId = data.supplierId?.value;
    tools.setPageNumber(data, searchParams, setValue);
    const apiData = await ApiAgentCommission.getAllAgentCommissions(data);
    setCommisionGroups(apiData);
    setValue("totalCount", apiData.totalCount);
    const queryString = tools.createQueryStringFromFromData(
      _.omit(data, ["totalPages", "totalCount"])
    );
    navigate(`/agentCommissions?${queryString}`);
  };

  return (
    <div>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              گروه های کمیسیون
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست گروه های کمیسیون تامین کننده ها
            </span>
          </h3>
          <div className="card-toolbar">
            <Button
              className="btn btn-primary"
              onClick={() => {
                setSelectedCommissionId(0);
                setShowCreateCommissionGroupModal(true);
              }}
            >
              <AddCircle className="mr-1" />
              ایجاد گروه کمیسیون جدید
            </Button>
          </div>
        </div>
        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 fs-normal text-gray">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col sm="6" xl="3" className="tb-reponsive px-2">
                            <Controller
                              name="supplierId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={supplierList?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  placeholder="تامین کننده"
                                  className="mt-5"
                                  field={field}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col xs="12" className="tb-reponsive px-3 mt-6">
                            <Button variant="success" type="submit" disabled={isSubmitting}>
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                            <Button
                              className="ml-3"
                              variant="light-danger"
                              type="submit"
                              disabled={isSubmitting}
                              onClick={() => tools.handleResetAdvanceSearchBox(watch, reset)}
                            >
                              <i className="fas fa-refresh text-small"></i>
                              حذف جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button
                    variant="secondary"
                    type="submit"
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? (
                      <Spinner animation="border" variant="warning" size="sm" />
                    ) : (
                      <SearchIcon />
                    )}
                  </Button>
                </InputGroup>
              </div>
              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                <DataGrid
                  data={commisionGroups}
                  setSelectedCommissionId={setSelectedCommissionId}
                  setShowCreateCommissionGroupModal={
                    setShowCreateCommissionGroupModal
                  }
                />
              </Col>
            </form>
          </FormProvider>
          {showCreateCommissionGroupModal && (
            <CreateCommissionGroupModal
              showCreateCommissionGroupModal={showCreateCommissionGroupModal}
              setShowCreateCommissionGroupModal={
                setShowCreateCommissionGroupModal
              }
              selectedCommissionId={selectedCommissionId}
            // allCommisionGroupsWithoutPagination={
            //   allCommisionGroupsWithoutPagination
            // }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default AgentCommision;
